import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  BooleanField,
  TextField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Справочник складов.
 *
 * Хранит места хранения товаров. Используется как dimension в складском ledger.
 */
export const AccountingWarehouseSchema = Type.Object({
  ...SystemFields,

  name: StringField({
    title: 'Название склада',
    minLength: 1,
    maxLength: 255,
    description: 'Название склада или точки хранения.',
  }),

  address: TextField({
    title: 'Адрес',
    nullable: true,
    description: 'Физический адрес склада.',
  }),

  is_active: BooleanField({
    title: 'Активен',
    default: true,
    description: 'Позволяет скрыть склад из справочника без удаления.',
  }),
});

export type AccountingWarehouse = Static<typeof AccountingWarehouseSchema>;

export default defineSchema({
  moduleName,
  tableName: 'warehouses',
  schema: AccountingWarehouseSchema,
  additionalIndexes: ['is_active'],
});
